(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('mousedown', () => {
  document.documentElement.setAttribute('data-using-mouse', 'true');
});
document.addEventListener('keydown', () => {
  document.documentElement.removeAttribute('data-using-mouse');
});

document.addEventListener("DOMContentLoaded", () => {

  const items = document.querySelectorAll(".main-nav > li");
  let active = null;
  const DESKTOP_BREAKPOINT = 1000;
  
  let isTouchDevice = window.matchMedia("(hover: none)").matches;
  
  const touchMediaQuery = window.matchMedia("(hover: none)");
  if (touchMediaQuery.addEventListener) {
    touchMediaQuery.addEventListener('change', (e) => {
      isTouchDevice = e.matches;
      closeAllMenus();
      ensureInnerDetailsState();
    });
  }

  document.addEventListener('mousedown', () => {
    document.body.setAttribute('data-using-mouse', 'true');
  });
  document.addEventListener('keydown', () => {
    document.body.removeAttribute('data-using-mouse');
  });

  const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;
  const isTouch   = () => isTouchDevice;

  // ─── ADD: grab MainMenu instance + overlay helper ────────────
  const mainMenuEl = document.querySelector('main-menu');
  function triggerOverlay(show) {
    if (mainMenuEl && typeof mainMenuEl.toggleOverlay === 'function') {
      mainMenuEl.toggleOverlay(show);
    }
  }
  // ─────────────────────────────────────────────────────────────

  const updateLabel = (item, isOpen) => {
    const summary = item.querySelector(':scope > details > summary');
    if (!summary) return;
    const template = summary.dataset.navLabel;
    if (template) {
      summary.setAttribute(
        'aria-label',
        template.replace('{state}', isOpen ? 'expanded' : 'collapsed')
      );
    }
    summary.setAttribute('aria-expanded', String(isOpen));
  };

 const closeAllMenus = () => {
    document.querySelectorAll('.main-nav details').forEach(d => {
      d.open = false;
      d.classList.remove('is-open');
    });
    document.querySelectorAll('.main-nav > li').forEach(i => {
      i.dataset.openedByClick = 'false';
      updateLabel(i, false);
    });
    active = null;
    triggerOverlay(false);
  };

  const closeOthers = (current) => {
    items.forEach(item => {
      if (item !== current) {
        const d = item.querySelector("details");
        if (d && d.open) {
          d.open = false;
          d.classList.remove("is-open");
        }
        item.dataset.openedByClick = 'false';
        updateLabel(item, false);
      }
    });
  };

  const open = (item) => {
    const d = item.querySelector("details");
    if (!d) return;
    closeOthers(item);
    d.open = true;
    d.classList.add("is-open");
    updateLabel(item, true);  // FIX: was d.setAttribute("aria-expanded","true")
    active = item;
    if (isDesktop()) {
      item.querySelectorAll('nav-menu details').forEach(nd => { nd.open = true; });
    }
    triggerOverlay(true);
  };

  const close = (item) => {
    const d = item.querySelector("details");
    if (!d) return;
    if (d.open) {
      d.open = false;
      d.classList.remove("is-open");
      updateLabel(item, false);  // FIX: was d.setAttribute("aria-expanded","false")
    }
    item.dataset.openedByClick = 'false';
    if (active === item) active = null;
    if (!active) triggerOverlay(false);
  };

  const toggle = (item) => {
    const d = item.querySelector("details");
    if (!d) return;
    if (d.open) {
      close(item);
    } else {
      open(item);
    }
  };


  // ENSURE INNER NAV-MENU DETAILS STATE

  const ensureInnerDetailsState = () => {
    if (isDesktop()) {
      document.querySelectorAll('.main-nav nav-menu details').forEach(d => {
        d.open = true;
      });
      const mainDisclosure = document.querySelector('.main-menu__disclosure');
      if (mainDisclosure) mainDisclosure.open = true;
      document.querySelectorAll('.child-nav-container, .child-nav, .main-nav__child').forEach(el => {
        el.style.removeProperty('display');
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('visibility');
        el.style.removeProperty('opacity');
      });
    } else {
      document.querySelectorAll('.main-nav nav-menu details').forEach(d => {
        d.open = false;
      });
    }
  };


  // MOBILE BACK BUTTON
 
  document.querySelectorAll('.back-button').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeAllMenus();
    });
  });

  // PER ITEM EVENTS

  const setupItemEvents = (item) => {
    const details = item.querySelector("details");
    const summary = item.querySelector("summary");
    const directLink = item.querySelector('a.main-nav__item--primary');

    if (directLink && !details) {
      directLink.setAttribute('role', 'menuitem');
      directLink.setAttribute('tabindex', '0');
      directLink.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          directLink.click();
        }
      });
      return;
    }

    if (!details || !summary) return;

    item.dataset.openedByClick = 'false';

    // FIX: Keep aria-haspopup for correct SR announcement of "submenu".

    summary.setAttribute('aria-haspopup', 'true');
    summary.setAttribute('aria-expanded', 'false');
    summary.setAttribute('tabindex', '0');

    const innerSpan = summary.querySelector('span.main-nav__item--primary');
    if (innerSpan) innerSpan.setAttribute('tabindex', '-1');


    // CLICK HANDLER
 

    summary.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (isDesktop()) {
        if (details.open) {
          close(item);
        } else {
          items.forEach(otherItem => {
            if (otherItem !== item && otherItem.dataset.openedByClick === 'true') {
              close(otherItem);
            }
          });
          item.dataset.openedByClick = 'true';
          open(item);
        }
      } else {
        toggle(item);
      }
    });

   
    // KEYBOARD
    summary.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.stopPropagation();
        toggle(item);
      }
      if (e.key === "Escape") {
        close(item);
        summary.focus();
      }
      if (e.key === "ArrowDown") {
        e.preventDefault();
        if (!details.open) open(item);
        setTimeout(() => {
          const firstLink = details.querySelector('a[href], button');
          if (firstLink) firstLink.focus();
        }, 5);
      }
    });

    // DESKTOP HOVER

    const mouseEnterHandler = () => {
      if (!isDesktop() || isTouch()) return;
      const clickedOpenItem = Array.from(items).find(i => i.dataset.openedByClick === 'true');
      if (clickedOpenItem && clickedOpenItem !== item) {
        close(clickedOpenItem);
      }
      if (item.dataset.openedByClick !== 'true') {
        open(item);
      }
    };

// mouse check with leave handler 
    const mouseLeaveHandler = (e) => {
      if (!isDesktop() || isTouch()) return;
      if (item.dataset.openedByClick !== 'true') {
        // If the mouse moved into a child of this item (e.g. the dropdown
        // panel), do nothing — the cursor is still "inside" the menu.
        if (e.relatedTarget && item.contains(e.relatedTarget)) return;
        setTimeout(() => {
          if (!item.matches(':hover')) {
            // Only blur when the user is in mouse mode. If the user is
            // keyboard-navigating (Tab / Shift+Tab), never steal focus —
            // that would silently drop keyboard position mid-traversal.
            const usingMouse = document.documentElement.hasAttribute('data-using-mouse');
            if (usingMouse) {
              const focused = item.querySelector(':focus');
              if (focused) focused.blur();
            }
            close(item);
          }
        }, 100);
      }
    };

    item.addEventListener("mouseenter", mouseEnterHandler);
    item.addEventListener("mouseleave", mouseLeaveHandler);

   
    // DETAILS TOGGLE EVENT
   
    details.addEventListener("toggle", () => {
      if (details.open) {
        closeOthers(item);
        details.classList.add("is-open");
        updateLabel(item, true);   // FIX: was details.setAttribute(...)
        active = item;
        if (isDesktop()) {
          item.querySelectorAll('nav-menu details').forEach(nd => { nd.open = true; });
        }
      } else {
        details.classList.remove("is-open");
        updateLabel(item, false);  // FIX: was details.setAttribute(...)
        if (active === item) active = null;
      }
    });
  };

  const initializeAllItems = () => {
    document.querySelectorAll(".main-nav > li").forEach(item => setupItemEvents(item));
  };

  initializeAllItems();


  // OUTSIDE CLICK

  document.addEventListener("click", (e) => {
    if (e.target.closest(".main-nav")) return;
    if (e.target.closest(".main-menu__toggle")) return;
    if (e.target.closest(".back-button")) return;
    if (active) close(active);
  });


  // ESC GLOBAL

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && active) {
      const activeDetails = active.querySelector("details");
      if (activeDetails && activeDetails.open) {
        const s = active.querySelector("summary");
        const focusIsInsideMenu = active.contains(document.activeElement);
        close(active);
        // Restore focus only for keyboard-opened menus; otherwise, close
        // without affecting the normal Tab order.
        if (focusIsInsideMenu && s) {
          s.focus();
        }
      }
    }
  });


  // FOCUS 

  document.addEventListener('focusin', (e) => {
    if (!isDesktop() || !active) return;
    const activeSummary = active.querySelector('summary');
    const activeMenu    = active.querySelector('.main-nav__child');
    const isInsideActive =
      (activeSummary && activeSummary.contains(e.target)) ||
      (activeMenu    && activeMenu.contains(e.target))    ||
      (active === e.target.closest('.main-nav > li'));
    if (!isInsideActive) close(active);
  });

  
  //  RESIZE HANDLER
  
  let resizeTimeout;
  let lastWasDesktop = isDesktop();

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const nowDesktop = isDesktop();
      if (nowDesktop !== lastWasDesktop) {
        closeAllMenus();
        ensureInnerDetailsState();
        if (nowDesktop && !isTouch()) {
          document.body.style.display = 'none';
          void document.body.offsetHeight;
          document.body.style.display = '';
          setTimeout(() => {
            document.querySelectorAll(".main-nav > li").forEach(item => {
              item.dispatchEvent(new MouseEvent('mouseleave', { view: window, bubbles: true, cancelable: true }));
            });
          }, 10);
        }
        lastWasDesktop = nowDesktop;
      }
    }, 100);
  });


  // INITIAL STATE ON LOAD

  ensureInnerDetailsState();

});

  document.addEventListener('mousedown', function () {
  document.body.classList.add('using-mouse');
  });
  document.addEventListener('keydown', function (e) {
  if (e.key === 'Tab') {
  document.body.classList.remove('using-mouse');
  }
  });

  } catch(e) { console.error(e); }
})();
})();
